"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Timestamp = ({ type, value, className }) => {
    const intl = (0, react_intl_1.useIntl)();
    const formatRelative = (input) => {
        const seconds = (new Date(input).valueOf() - new Date().valueOf()) / 1000;
        const minutes = (new Date(input).valueOf() - new Date().valueOf()) / (1000 * 60);
        const hours = (new Date(input).valueOf() - new Date().valueOf()) / (1000 * 60 * 60);
        const days = (new Date(input).valueOf() - new Date().valueOf()) / (1000 * 60 * 60 * 24);
        if (Math.abs(seconds) < 60) {
            return intl.formatRelativeTime(Math.floor(seconds), 'second');
        }
        if (Math.abs(minutes) < 60) {
            return intl.formatRelativeTime(Math.floor(minutes), 'minute');
        }
        if (Math.abs(hours) > 24) {
            return intl.formatRelativeTime(Math.floor(days), 'day');
        }
        return intl.formatRelativeTime(Math.floor(hours), 'hour');
    };
    let result = intl.formatDate(value);
    if (type === 'relative') {
        result = formatRelative(value);
    }
    if (type === 'humanized') {
        result = intl.formatDate(value, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    }
    return (0, jsx_runtime_1.jsx)("time", { className: className, children: result });
};
exports.default = Timestamp;
